import React, { useContext, useMemo, forwardRef } from 'react'
import { FormControlLabel, Checkbox, Tooltip } from '@mui/material'
import { LoadingContext } from '../M_Utils'

export const M_CheckBox = forwardRef(({
    label, checked, icon,
    checkedIcon, onChange, disabled, color, fontSize,
    required, labelColor, tooltipName, noPadding
}, ref) => {

    const ctx = useContext(LoadingContext)

    color = color || ctx.primaryColor || 'var(--color-black)'
    labelColor = labelColor || ctx.secondaryColor || 'var(--color-black)'

    const handleKeyPressEvent = (event) => {
        if (event.key === 'Enter') {
            handleChange({ target: { checked: !checked } })
        }
    }

    const handleChange = (event) => {
        if (onChange) {
            onChange(event)
        }
    }

    const checkBox = useMemo(() => {
        return (
            <FormControlLabel
                sx={{
                    margin: !label ? '0px' : '5px 0px',
                    color: 'var(--color-black)',
                    '& .MuiSvgIcon-root': { fontSize: fontSize },
                }}
                label={label}
                control={
                    <Checkbox
                        checked={checked}
                        sx={{
                            color: color,
                            '&.Mui-checked': {
                                color: color,
                            },
                            '&.MuiCheckbox-root:hover': {
                                backgroundColor: 'transparent',
                            },
                            '& .MuiSvgIcon-root': { fontSize: fontSize },
                            padding: noPadding ? '0px' : '9px',
                        }}
                        icon={icon}
                        disabled={disabled}
                        checkedIcon={checkedIcon}
                        onChange={onChange}
                        required={required}
                        onKeyDown={handleKeyPressEvent}
                        inputRef={ref}
                    />
                }
            />
        )
    }, [checked, icon, disabled, checkedIcon, onChange, required, color, fontSize, noPadding, label, ref])

    return (
        <Tooltip title={tooltipName || ""}>
            {checkBox}
        </Tooltip>
    )
})